// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2sWHW","head":"ProcedureTableInfo_head__B4x0_"};